import { render } from "./CardImg.vue?vue&type=template&id=fca7a496"
import script from "./CardImg.vue?vue&type=script&lang=js"
export * from "./CardImg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__